import React from 'react';
import c from '../../constant';
import { Modal, ModalOverlay, ModalContent, ModalHeader, ModalBody, ModalCloseButton, Button, Box, Flex } from '@chakra-ui/react';
import { Formik, Form } from 'formik';
import * as Yup from 'yup';
import TextFormField from '../form/TextFormField';
import DateRangeFormField from '../form/DateRangeFormField';
import moment from 'moment';
import { useTranslation } from 'react-i18next';
import RadioFormField from '../form/RadioFormField';
import 'moment/locale/en-gb';

const filterSchema = Yup.object().shape({
	no: Yup.number(),
	reason: Yup.string(),
	type: Yup.string(),
	createdDate: Yup.string(),
	unreadOnly: Yup.boolean(),
	status: Yup.string(),
});

function MissionRecordFilter({ isOpen, onClose, callback, status = '', no = '', reason = '', type = '', fromDate = null, toDate = null, read = null }) {
	moment.locale('en-gb');
	const { t } = useTranslation();

	let defaultRange = '';
	if (fromDate && toDate) {
		const defaultFrom = JSON.parse(fromDate);

		const defaultTo = JSON.parse(toDate);
		defaultRange = {
			from: defaultFrom,
			to: defaultTo,
		};
	}

	return (
		<>
			<Modal borderRadius={c.borderRadius} isOpen={isOpen} onClose={onClose}>
				<ModalOverlay />
				<ModalContent borderRadius={c.borderRadius}>
					<ModalHeader>{t('Filter')}</ModalHeader>
					<ModalCloseButton />
					<ModalBody>
						<Formik
							initialValues={{
								no: no ? no : '',
								reason: reason ? reason : '',
								type: type ? type : '',
								createdDate: defaultRange ? JSON.stringify(defaultRange) : '',
								unreadOnly: read ? read : '',
								status: status ? status : '',
							}}
							validationSchema={filterSchema}
							onSubmit={(values) => {
								let url = '/list?page=1';
								if (values?.no) {
									url += `&no=${values?.no}`;
								}
								if (values?.reason) {
									url += `&reason=${values?.reason}`;
								}
								if (values?.type) {
									url += `&type=${values?.type}`;
								}
								if (values?.createdDate) {
									const tmpDate = JSON.parse(values?.createdDate);
									if (tmpDate?.from && tmpDate?.to) {
										const dateFrom = JSON.stringify(tmpDate.from);
										const dateTo = JSON.stringify(tmpDate.to);
										url += `&fromDate=${dateFrom}&toDate=${dateTo}`;
									}
								}
								if (values?.status) {
									url += `&status=${values?.status}`;
								}
								callback(url);
								onClose();
							}}
						>
							{(props) => (
								<Box pb="4">
									<Form>
										<TextFormField {...props} label="Number" name="no" type="number" />
										<TextFormField {...props} label="Reason" name="reason" type="text" />

										<RadioFormField
											label="Category"
											name="type"
											radios={[
												{ label: 'Request for Meeting Participation (Phnom Penh)', value: 'RequestForMeetingParticipation' },
												{ label: 'Mission (Domestic and International)', value: 'Mission' },
												{
													label: 'Attendance Request: Forgot to Check-in/Check-out',
													value: 'AttendanceRequest',
												},
											]}
											initValue={type}
										/>

										<center>
											<DateRangeFormField {...props} label="Created Date" name="createdDate" initialDate={{ fromDate, toDate }} />
										</center>

										<RadioFormField
											label="Status"
											name="status"
											radios={[
												{ label: 'approved', value: 'APPROVED' },
												{ label: 'rejected', value: 'REJECTED' },
											]}
											initValue={status}
										/>

										<Flex mt="32px" justifyContent="flex-end">
											<Button
												id="login-btn"
												variant="solid"
												size="md"
												h="42px"
												w="128px"
												type="submit"
												borderRadius={c.borderRadius}
												color="#3498db"
											>
												{t('Apply')}
											</Button>
											<Button
												size="md"
												h="42px"
												ml={4}
												w="128px"
												onClick={() => {
													callback('/list?page=1');
													onClose();
												}}
												variant="ghost"
											>
												{t('Clear')}
											</Button>
										</Flex>
									</Form>
								</Box>
							)}
						</Formik>
					</ModalBody>
				</ModalContent>
			</Modal>
		</>
	);
}

export default MissionRecordFilter;
